/**
 * The arena BERSERK window — the old `showArenaBerserk` (PlayChess index.js
 * L4552-4568), as a selector (M4 §4).
 *
 * Lane-side and not in the shared core because it is the CONTROL BAR's rule: the
 * core records the badges and the refusal (`selectArenaBerserk`), but "may I
 * berserk right now" is five conditions over three slices and the old screen
 * computes it at the render site too.
 *
 * The window: an arena, the server says berserk is enabled, a LIVE game of mine
 * (never a watched one), I have made at most one move, and I have not berserked
 * this game already. `moves` holds PLIES, so after n plies white has made
 * `ceil(n/2)` moves and black `floor(n/2)` — the server refuses outside the same
 * window anyway.
 */
import {selectBoardSource} from '@/Store/liveGame/selectors';
import {id} from '@/Store/liveGame/state';
import type {LiveGameState} from '@/Store/liveGameStore';

/** old L4556-4559: my own move count, derived from the ply count. */
export const myMoveCount = (state: LiveGameState): number => {
  const plies = state.game.moves.length;
  const iAmWhite =
    !!state.session.me && id(state.game.whiteId) === state.session.me;
  return iAmWhite ? Math.ceil(plies / 2) : Math.floor(plies / 2);
};

export const selectShowBerserk = (s: LiveGameState): boolean =>
  s.tournament.mode === 'arena' &&
  !!s.arena.status?.berserkEnabled &&
  s.game.phase === 'playing' &&
  selectBoardSource(s) === 'live' &&
  myMoveCount(s) <= 1 &&
  !s.arena.myBerserk;

export default selectShowBerserk;
